// 悟空老师筛选

import React, { useMemo, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';
import Title from '@/components/Teachers/Title';
import Mobile from '@/components/Device/Mobile';
import PC from '@/components/Device/PC';
import { MyContext } from '@/config/context-manager';
import styles from './style.module.scss';
import Step from './Step';
import StepMobile from './Step.mobile';

const TeacherScreening = () => {
  const { t } = useTranslation('teachers');
  const { locale } = useContext(MyContext);
  const step = t('悟空老师筛选-步骤');
  const steps = useMemo(() => step.split('|'), [step]);

  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <Title>{t('悟空老师筛选-标题')}</Title>
      <div className={styles.stepWrapper}>
        <Mobile>
          <StepMobile lang={steps} />
        </Mobile>
        <PC>
          <Step lang={steps} />
        </PC>
      </div>
    </section>
  );
};

export default TeacherScreening;
